
/**
 * 강의 콘텐츠 지원 플랫폼 환경
 */
export type UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport = typeof UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport[keyof typeof UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport = {
  IDE_ONLY: 'IDE_ONLY',
  WEB_ONLY: 'WEB_ONLY',
  IDE_AND_WEB: 'IDE_AND_WEB',
} as const;
